import { dynamicWithRetry } from '@cc-shopping/utils/dynamic/dynamicWithRetry';
import type { SVGProps } from 'react';
import type { CardFinderBranch } from '../types';
import { IllustrationPlaceholder } from './Placeholder';

type IllustrationProps = SVGProps<SVGSVGElement>;

const dynamicIllustrationOptions = {
  loading: () => <IllustrationPlaceholder />,
  ssr: false,
} as const;

const TravelIllustration = dynamicWithRetry<IllustrationProps>(
  () => import('./Travel').then(mod => ({ default: mod.TravelIllustration })),
  { ...dynamicIllustrationOptions, componentName: 'TravelIllustration' },
);

const CashBackIllustration = dynamicWithRetry<IllustrationProps>(
  () => import('./CashBack').then(mod => ({ default: mod.CashBackIllustration })),
  { ...dynamicIllustrationOptions, componentName: 'CashBackIllustration' },
);

const BalanceTransferIllustration = dynamicWithRetry<IllustrationProps>(
  () => import('./BalanceTransfer').then(mod => ({ default: mod.BalanceTransferIllustration })),
  { ...dynamicIllustrationOptions, componentName: 'BalanceTransferIllustration' },
);

const SavingInterestIllustration = dynamicWithRetry<IllustrationProps>(
  () => import('./SavingInterest').then(mod => ({ default: mod.SavingInterestIllustration })),
  { ...dynamicIllustrationOptions, componentName: 'SavingInterestIllustration' },
);

const BuildingCreditIllustration = dynamicWithRetry<IllustrationProps>(
  () => import('./BuildingCredit').then(mod => ({ default: mod.BuildingCreditIllustration })),
  { ...dynamicIllustrationOptions, componentName: 'BuildingCreditIllustration' },
);

export const BRANCH_ILLUSTRATIONS_MAP: Record<
  CardFinderBranch,
  { SVGComponent: React.ComponentType<IllustrationProps>; alt: string }
> = {
  travel: {
    SVGComponent: TravelIllustration,
    alt: 'Plane, palm, sun and credit card',
  },
  'cash-back': {
    SVGComponent: CashBackIllustration,
    alt: 'Open wallet getting cash',
  },
  'balance-transfer': {
    SVGComponent: BalanceTransferIllustration,
    alt: 'Money flowing from credit card to credit card',
  },
  'saving-interest': {
    SVGComponent: SavingInterestIllustration,
    alt: 'Trend going up and positive charts',
  },
  'building-credit': {
    SVGComponent: BuildingCreditIllustration,
    alt: 'Shining credit card and bags filled with multiple products',
  },
};
